import { render, staticRenderFns } from "./shipment-emails.vue?vue&type=template&id=0c1b3882&scoped=true"
import script from "./shipment-emails.vue?vue&type=script&lang=js"
export * from "./shipment-emails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c1b3882",
  null
  
)

export default component.exports